import React from 'react';

const VirgoIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 20V80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M40 20V80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M60 20V80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M80 80C80 60 70 50 60 50C50 50 40 60 40 80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M80 80C90 80 95 70 95 60C95 40 80 20 60 20" stroke={color} strokeWidth="5" strokeLinecap="round"/>
  </svg>
);

export default VirgoIcon;
